import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { Publication } from '@portal-core/publications/models/publication.model';
import { PublicationsService } from '@portal-core/publications/services/publications.service';

@Component({
  selector: 'mc-publication-progress-bar',
  templateUrl: './publication-progress-bar.component.html',
  styleUrls: ['./publication-progress-bar.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PublicationProgressBarComponent {
  @Input() publication: Publication;
  @Input() showHeader?: boolean = true;
  @Input() showFooter?: boolean = true;

  get colorForPublicationState(): string {
    return this.publicationsService.getColorForPublication(this.publication);
  }

  get textColorClassForPublicationState(): string {
    return `mc-text-${this.colorForPublicationState}`;
  }

  get statusDisplayText(): string {
    return this.publicationsService.getStatusDisplayText(this.publication);
  }

  get errorCount(): number {
    return this.publication?.Process?.LastProcessAttempt?.ErrorCount ?? 0;
  }

  get warningCount(): number {
    return this.publication?.Process?.LastProcessAttempt?.WarningCount ?? 0;
  }

  constructor(private publicationsService: PublicationsService) { }
}
